import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { GetTeamMemberListApi } from "../../../api/request/team/team";
import columns from "../../../columns/reports/completeJobReport";
import SkeletonTable from "../../../components/table/SkeletonTable";
import { GetCompleteJobReportApi } from "../../../api/request/reports/report";

const CompleteJobReport = () => {
  const [getCompleteJobReport, setCompleteJoReport] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getCompleteJobReportList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetCompleteJobReportApi();
      if (data?.status) {
        setCompleteJoReport(
          data?.data?.map((item) => {
            return {
              ...item,
              organizer: (
                <div className="font-bold highlight-text capitalize">
                  {item?.organizer?.organizer_name_slug}
                </div>
              ),
              name: item?.users?.name,
              email: item?.users?.email,
              task_name: item?.task_master?.name,
              assignTo: item?.employee?.name,
              startDate: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              status: (
                <p className="text-green-500 font-bold uppercase">
                  {item?.status}
                </p>
              ),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setCompleteJoReport([]);
      setIsLoading(false);
    }
  };

  const getEmployeeList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetTeamMemberListApi();
      if (data.status) {
        columns.map((item) => {
          if (item.dataIndex === "assignTo") {
            item.filters = data?.data?.map((item) => {
              return { text: item?.name, value: item?.name };
            });
          }
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCompleteJobReportList();
    getEmployeeList();
  }, []);

  return (
    <div className="border-2 rounded-xl my-5">
      <div className="flex justify-between mx-5 mt-5">
        <p className=" font-semibold text-2xl">Complete Job Reports</p>
      </div>
      <div className="my-6">
        <SkeletonTable
          searchingFields={["name", "email"]}
          dateFilterFields={["startDate"]}
          columns={columns}
          data={getCompleteJobReport}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default CompleteJobReport;
